import Request from './request'

async function fetch (data) {
  return Request('get', 'api/food-templates', data)
}

async function save (id, data) {
  // 编辑或新建数据（有id为编辑，没有id为新建）
  if (id) return Request('patch', 'api/food-templates/edit?id=' + id, data)
  else return Request('post', 'api/food-templates/add', data)
}

async function del(id) {// 删除数据
    return Request('delete', "api/food-templates/delete/" + id);
}

export default {
  fetch,
  save,
  del,
}
